module.exports = __webpack_public_path__ + "img/featured-offer.afade4a6.png";